import { http, HttpResponse } from "msw";
import { BASE_URL, CLIENT_IDS, isClient } from "../constants";
import { loadMock, toDetailsResponse } from "../utils";

const discountHandlers = [
  http.post(`${BASE_URL}/v1.0/Category`, async ({ request }) => {
    if (!isClient(request, CLIENT_IDS.discounts)) return;
    return HttpResponse.json(await loadMock("Discounts/categories"));
  }),
  http.post(`${BASE_URL}/v1.0/item/WithDetails`, async ({ request }) => {
    if (!isClient(request, CLIENT_IDS.discounts)) return;
    return HttpResponse.json(await loadMock("Discounts/items"));
  }),
  http.post(`${BASE_URL}/v1.0/item/Details`, async ({ request }) => {
    if (!isClient(request, CLIENT_IDS.discounts)) return;
    const { code } = (await request.json()) as { code: string };
    return HttpResponse.json(toDetailsResponse(await loadMock("Discounts/items"), code));
  }),
];

export { discountHandlers };
